// App.js
import React from "react";
import "../../styles/Slider.css";
import BackgroundImage from "../../assets/images/laptop-girl.png";
import { Link } from "react-router-dom";

const App = () => {
  return (
    <>
      <div className="banner-section">
        <div className="banner-overlay"></div>
        <div className="banner-gradient-accent"></div>
        <div className="container-banner">
          <div className="text-content">
            {/* <div className="banner-badge"> Digital Excellence</div> */}
            <h1 className="banner-title">
              Grow Your Business with Digital Marketing, Web Development & AI
              Automation <br />
            </h1>
            <p className="banner-description">
              In nowadays’s aggressive digital global, your business desires
              greater than just a web presence. We are a leading{" "}
              <b>digital marketing agency</b> and <b>web development company</b> assisting brands growth visibility, generate qualified leads, and
              scale quicker with end result-pushed virtual solutions.
            </p>
            <div className="cta-buttons">
              <Link to="/Contact" className="btn btn-primary">
                <span>Get Free Consultation</span>
                <span className="arrow">→</span>
              </Link>
              <Link to="/portfolio" className="btn btn-secondary">
                <span>View Our Work</span>
              </Link>
            </div>
          </div>
          <div className="image-content">
            <div className="image-wrapper">
              <img src={BackgroundImage} alt="Web Development Solutions" />
            </div>
          </div>
        </div>
      </div>
      <div className="short-navbar">
        <ul className="short-navbar-list">
          <li>
            <a href="/seo-agency-noida">SEO Services</a>
          </li>
          <li>
            <a href="/content-marketing-services">Content Marketing</a>
          </li>
          <li>
            <a href="/ui-ux-design-services">UI/UX Design </a>
          </li>
          <li>
            <a href="/web-development-company-in-noida">Web Development</a>
          </li>
          <li>
            <a href="/branding-agency-noida">Branding</a>
          </li>
          <li>
            <a href="/ai-automation-services">AI Automation</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default App;
